var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IxWmsLayer',{attrs:{"url":_vm.url,"layers":_vm.layer,"clip-features":_vm.features}})}
var staticRenderFns = []

export { render, staticRenderFns }